// extracted by mini-css-extract-plugin
export default {"Box":"TimelineDivider-module__Box--mXVKT","Box_1":"TimelineDivider-module__Box_1--UKj6b","Box_2":"TimelineDivider-module__Box_2--WcW6m"};